import { create } from 'zustand';

/**
 * terminalStore — estado del lector Stripe Terminal
 *
 * status:
 *   'disconnected'  — sin lector conectado
 *   'discovering'   — buscando lectores disponibles
 *   'connecting'    — conectando al lector seleccionado
 *   'connected'     — lector listo para cobrar
 */
export const useTerminalStore = create((set) => ({
  status: 'disconnected',
  reader: null,
  error:  null,

  setStatus:  (status) => set({ status, error: null }),
  setReader:  (reader) => set({ reader, status: reader ? 'connected' : 'disconnected', error: null }),
  setError:   (error)  => set({ error, status: 'disconnected' }),
  handleDisconnect: () => set({ status: 'disconnected', reader: null, error: null }),
}));
